export default __webpack_public_path__ + "static/media/1.547b7d0c.png";